import * as constants from './actions';

import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {
    isSubmitting: false
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.PETITION_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state)
            };
        case constants.PETITION_SUCCESS:
            return {
                ...state,
                completePetition: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                thankYouText: payload.thankYouText,
                confirmationTitle: payload.confirmationTitle
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    thankYouText: payload.thankYouText,
                    thankYouTitle: payload.thankYouTitle,
                    useLocalRepresentative: payload.useLocalRepresentative,
                    localRepresentativeState: payload.localRepresentativeState
                }
            };
        case constants.PETITION_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.PETITION_ERROR:
            return {
                ...state,
                petitionError: payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Petition/reducer.js